<ejs-dialog target=".dialogs" class="steps-dialog" [visible]='visible' [animationSettings]='dialogService.getAnimationSettings()' [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()' [isModal]="true" [allowDragging]="false" [width]="'60%'" [height]="'60vh'" [zIndex]="999" [showCloseIcon]="false">
  <ng-template #header class="p-1">
    <app-step-header [steps]="steps" [(activeStep)]="activeStep" (activeStepChange)="handleStepChange($event)"></app-step-header>
  </ng-template>
  <ng-template #content>
    <div class="d-flex h-100">
      <!-- Left Column -->
      <div class="col-md-4 col-12 d-none d-md-flex flex-column left-container h-100 p-3">
        <div class="text-center mb-4">
          <app-headline [title]="'CALADDEVENT' | translate" [type]="'h5'"></app-headline>
        </div>
        <app-step-content [steps]="steps" [(activeStep)]="activeStep" (activeStepChange)="handleStepChange($event)"></app-step-content>
        <div class="save-button-container text-center mt-3 d-none d-md-block">
          <app-form-button [text]="'SAVE' | translate"  (click)="save()" [cssClass]="'e-primary w-100'"></app-form-button>
        </div>
      </div>

      <!-- Right Column -->
      <div class="col-md-8 col-12 d-flex flex-column flex-grow-1 right-container h-100 overflow-y-auto p-3">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div class="d-flex align-items-center">
            <app-headline [title]="steps[activeStep]" [type]="'h5'"></app-headline>
            <div class="ms-2">
              <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('CALEVENTGUESTSHELP' | translate)" [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
            </div>
          </div>
          <app-form-button [style]="'btn'" (click)="close()" [cssClass]="'btn-close'"></app-form-button>
        </div>

        <div class="custom-scrollbar overflow-y-auto">
          <form class="p-1 d-flex flex-column h-100">
            @switch(activeStep) {
              @case(0) {
                <app-form-label [label]="'CALEVENTNAME' | translate" [maxChars]="35" [currentChars]="calendarEventForm.controls['name'].value.length"></app-form-label>
                <app-form-input [placeholder]="('CALEVENTNAME' | translate)" [label]="('CALEVENTNAME' | translate)" [errorText]="('CALEVENTNAMEREQUIRED' | translate)" [fCN]="'name'" [fG]="calendarEventForm" [maxChars]="35"></app-form-input>
                
                <app-form-label [label]="'CALPRIORITYLEVEL' | translate"></app-form-label>
                <div class="mb-3">
                  <app-form-dropdown [fG]="calendarEventForm" [fCN]="'priority'" [dataSource]="priorityOptions" [placeholder]="'SELECT' | translate" [marker]="'priority'"></app-form-dropdown>
                </div>
                <app-form-label [label]="'CALEVENTDESCRIPTION' | translate" [maxChars]="100" [currentChars]="calendarEventForm.controls['description'].value.length"></app-form-label>
                <div class="mb-3">
                  <app-form-textarea [placeholder]="('CALEVENTDESCRIPTION' | translate)" [errorText]="('CALEVENTDESCRIPTIONREQUIRED' | translate)" [fCN]="'description'" [fG]="calendarEventForm" [maxChars]="100" [rows]="4"></app-form-textarea>
                </div>
                <app-form-label [label]="'CALEVENTLOCATIONLABEL' | translate" [maxChars]="250" [currentChars]="calendarEventForm.controls['location'].value.length"></app-form-label>
                <div class="mb-3">
                  <app-form-textarea [placeholder]="('CALEVENTLOCATION' | translate)" [fCN]="'location'" [fG]="calendarEventForm" [maxChars]="250" [rows]="4"></app-form-textarea>
                </div>
              }
              @case(1) {
                <div class="row">
                  <!-- Start Date -->
                  <div class="col-12 col-md-6 mb-3">
                    <app-form-label [label]="'CALEVENTSTARTDATE' | translate"></app-form-label>
                    @if(calendarEventForm.get('isWholeday')?.value) {
                      <app-form-date
                        [fG]="calendarEventForm"
                        [fCN]="'onDateStart'"
                        [placeholder]="'CALEVENSELECTSTARTDATE' | translate"
                      ></app-form-date>
                    } @else {
                      <app-form-date-time
                        [fG]="calendarEventForm"
                        [fCN]="'onDateStart'"
                        [placeholder]="'CALEVENSELECTSTARTDATE' | translate"
                        [step]="calendarStepMinutes"
                      ></app-form-date-time>
                    }
                  </div>
    
                  <!-- End Date-->
                  <div class="col-12 col-md-6 mb-3">
                    <app-form-label [label]="'CALEVENTENDDATE' | translate"></app-form-label>
                    @if(calendarEventForm.get('isWholeday')?.value){
                      <app-form-date
                        [fG]="calendarEventForm"
                        [fCN]="'onDateEnd'"
                        [placeholder]="'CALEVENSELECTENDDATE' | translate"
                      ></app-form-date>
                    } @else {
                      <app-form-date-time
                        [fG]="calendarEventForm"
                        [fCN]="'onDateEnd'"
                        [placeholder]="'CALEVENSELECTENDDATE' | translate"
                        [step]="calendarStepMinutes"
                      ></app-form-date-time>
                    }
                  </div>
                </div>
    
                <!-- Whole day and Timezone-->
                <div class="row">
                  <div class="col-12 col-md-6 mb-3">
                    <div class="d-flex flex-wrap gap-3">
                      <app-form-checkbox
                        [fCN]="'isWholeday'"
                        [fG]="calendarEventForm"
                        [cssClass]="'pb-1 lh-base'"
                        [labelPosition]="'After'"
                        [label]="'CALLALLDAYEVENT' | translate"
                      ></app-form-checkbox>
                    </div>
                  </div>
                </div>
    
                <!-- Timezone  and notification select-->
                  <div class="row"> 
                    <!-- Start Timezone -->
                    <div class="col-12 col-md-6 mb-3">
                      <app-form-label [label]="'STARTTIMEZONE' | translate"></app-form-label>
                      <app-form-dropdown
                        [fG]="calendarEventForm"
                        [fCN]="'startTimeZone'"
                        [dataSource]="customTimezone"
                        [placeholder]="'SELECT' | translate"
                        [allowFiltering]="true"
                        [mapping]="{text: 'name', value: 'id'}"
                        (search)="timezoneSearch($event)"
                      ></app-form-dropdown>
                    </div>
                    <div class="col-12 col-md-6 mb-3">
                    @if(calendarEventForm.get('isWholeday')?.value === false){
                      <app-form-label [label]="'CALEVENTNOTIFYBEFOREMINUTES' | translate"></app-form-label>
                      <app-form-numeric [fG]="calendarEventForm" [fCN]="'notifyBeforeMinutes'"></app-form-numeric>
                    } @else {
                      <app-form-label [label]="'CALEVENTNOTIFYAT' | translate"></app-form-label>
                      <app-form-time 
                        [placeholder]="'SELECTTIME' | translate"
                        [fG]="calendarEventForm"
                        [fCN]="'notifyAt'"
                        >
                      </app-form-time>
                    }
                  </div>
                  </div>
    
                <!-- BASE REPEAT -->
                @if(calendarEventForm.get('isWholeday')?.value === false){
                  <div class="row">
                    <!-- Repeat -->
                    <div class="col-12 col-md-6 mb-3">
                      <app-form-label [label]="'CALEVENTREPEATS' | translate"></app-form-label>
                      <app-form-dropdown [fG]="calendarEventForm" [fCN]="'repeatType'" [dataSource]="repeatTypeOptions" [placeholder]="'SELECT' | translate" [cssClass]="'me-2'"></app-form-dropdown>
                    </div>
      
                    <!-- Repeats Every-->
                    <div class="col-12 col-md-6 mb-3" [class.d-none]="calendarEventForm.get('repeatType')?.value === 'never'">
                      <app-form-label [label]="'CALEVENTREPEATSEVERY' | translate"></app-form-label>
                      <div class="d-flex align-items-center gap-1">
                        <app-form-numeric [fG]="calendarEventForm" [fCN]="'repeatEvery'" [min]="1"></app-form-numeric>
                        <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-muted'">{{ repeatUnit | translate }}</app-content>
                      </div>
                    </div>
                  </div>
      
                  <!-- Daily Repeat Section-->
                  <div class="row" [class.d-none]="calendarEventForm.get('repeatType')?.value !== 'daily'">
                    <!-- Repeat Days End-->
                    <div class="col-6 col-md-3 mb-3">
                      <app-form-label [label]="'CALEVENTREPEATEND' | translate"></app-form-label>
                      <app-form-dropdown [fG]="calendarEventForm" [fCN]="'repeatEndType'" [dataSource]="repeatEndOptions" [placeholder]="'SELECT' | translate" [cssClass]="'me-2'"></app-form-dropdown>
                    </div>
                    <div class="col-6 col-md-3 mb-3">
                      <div>&nbsp;</div>
                      <!-- Date Picker: show only if 'until' -->
                      <div [class.d-none]="calendarEventForm.get('repeatEndType')?.value !== 'until'">
                        <app-form-date
                            [fG]="calendarEventForm"
                            [fCN]="'repeatDaysUntil'"
                            [placeholder]="'CALEVENSELECTSTARTDATE' | translate"
                          ></app-form-date>
                      </div>
                      <!-- Numeric Input: show only if 'count' -->
                      <div [class.d-none]="calendarEventForm.get('repeatEndType')?.value !== 'count'">
                        <app-form-numeric [fG]="calendarEventForm" [fCN]="'repeatDaysCount'"></app-form-numeric>
                      </div>
                    </div>
                  </div>
      
                  <!-- Weekly Repeat Section -->
                  <div class="row" [class.d-none]="calendarEventForm.get('repeatType')?.value !== 'weekly'">
                    <div class="col-12 col-md-6 mb-3">
                      <app-form-label [label]="'CALEVENTREPEATON' | translate"></app-form-label>
      
                      <div class="d-flex flex-wrap gap-2">
                        @for(day of weekdayOptions; track $index) {
                          <button
                            type="button"
                            class="e-round e-lib e-btn e-control"
                            [class.e-active]="!calendarEventForm.get('repeatOn')?.value?.includes(day.value)"
                            [class.e-primary]="calendarEventForm.get('repeatOn')?.value?.includes(day.value)"
                            (click)="toggleRepeatDay(day.value)"
                          >
                            {{ day.label }}
                          </button>
                        }
                      </div>
                    </div>
                    <!-- End Type + Conditional Field -->
                    <div class="col-12 col-md-6 mb-3">
                      <div class="row">
                        <div class="col-6 col-md-6 mb-3">
                            <app-form-label [label]="'CALEVENTREPEATEND' | translate"></app-form-label>
                            <app-form-dropdown
                              [fG]="calendarEventForm"
                              [fCN]="'repeatEndType'"
                              [dataSource]="repeatEndOptions"
                              [placeholder]="'SELECT' | translate"
                            ></app-form-dropdown>
                        </div>
                        <div class="col-6 col-md-6 mb-3">
                          <div>&nbsp;</div>
                          <!-- Repeat Until Date -->
                          <div [class.d-none]="calendarEventForm.get('repeatEndType')?.value !== 'until'">
                            <app-form-date
                              [fG]="calendarEventForm"
                              [fCN]="'repeatDaysUntil'"
                              [placeholder]="'CALEVENSELECTSTARTDATE' | translate"
                            ></app-form-date>
                          </div>
      
                          <!-- Repeat Count -->
                          <div [class.d-none]="calendarEventForm.get('repeatEndType')?.value !== 'count'">
                            <app-form-numeric [fG]="calendarEventForm" [fCN]="'repeatDaysCount'"></app-form-numeric>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
      
                  <!-- Monthly repeat -->
                  <div class="row" [class.d-none]="calendarEventForm.get('repeatType')?.value !== 'monthly'">
                    <!-- Repeat On Section -->
                    <div class="col-12 col-md-6 mb-3">
                      <app-form-label [label]="'CALEVENTREPEATON' | translate"></app-form-label>
      
                      <!-- Day of Month Option -->
                      <div class="d-flex align-items-center gap-2 mb-2">
                        <app-form-radio [fG]="calendarEventForm" [fCN]="'monthlyRepeatMode'" [value]="true" [placeholder]="'DAY' | translate" [cssClass]="'e-normal'"></app-form-radio>
      
                        <app-form-numeric
                          [fG]="calendarEventForm"
                          [fCN]="'monthlyRepeatDay'"
                        ></app-form-numeric>
                      </div>
      
                      <!-- Ordinal Weekday Option -->
                      <div class="d-flex align-items-center gap-2">
                        <app-form-radio [fG]="calendarEventForm" [fCN]="'monthlyRepeatMode'" [value]="false" [placeholder]="'&nbsp;'" [cssClass]="'e-normal'"></app-form-radio>
      
                        <app-form-dropdown
                          [fG]="calendarEventForm"
                          [fCN]="'monthlyOrdinal'"
                          [dataSource]="ordinalOptions"
                        ></app-form-dropdown>
      
                        <app-form-dropdown
                          [fG]="calendarEventForm"
                          [fCN]="'monthlyWeekday'"
                          [dataSource]="weekdayOptionsLong"
                        ></app-form-dropdown>
                      </div>
                    </div>
      
                    <!-- End Type + Conditional Field -->
                    <div class="col-12 col-md-6 mb-3">
                      <div class="row">
                        <div class="col-6 col-md-6 mb-3">
                            <app-form-label [label]="'CALEVENTREPEATEND' | translate"></app-form-label>
                            <app-form-dropdown
                              [fG]="calendarEventForm"
                              [fCN]="'repeatEndType'"
                              [dataSource]="repeatEndOptions"
                              [placeholder]="'SELECT' | translate"
                            ></app-form-dropdown>
                        </div>
                        <div class="col-6 col-md-6 mb-3">
                          <div>&nbsp;</div>
                          <!-- Repeat Until Date -->
                          <div [class.d-none]="calendarEventForm.get('repeatEndType')?.value !== 'until'">
                            <app-form-date
                              [fG]="calendarEventForm"
                              [fCN]="'repeatDaysUntil'"
                              [placeholder]="'CALEVENSELECTSTARTDATE' | translate"
                            ></app-form-date>
                          </div>
      
                          <!-- Repeat Count -->
                          <div [class.d-none]="calendarEventForm.get('repeatEndType')?.value !== 'count'">
                            <app-form-numeric [fG]="calendarEventForm" [fCN]="'repeatDaysCount'"></app-form-numeric>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
      
                  <!-- Yearly repeat -->
                  <div class="row" [class.d-none]="calendarEventForm.get('repeatType')?.value !== 'yearly'">
                    <div class="col-12 col-md-6">
                      <app-form-label [label]="'CALEVENTREPEATS' | translate"></app-form-label>
                      <app-form-dropdown [fG]="calendarEventForm" [fCN]="'repeatMonth'" [dataSource]="monthOptions" [cssClass]="'me-2'"></app-form-dropdown>
                    </div>
                    <!-- End Type + Conditional Field -->
                    <div class="col-12 col-md-6">
                      <div class="row">
                        <div class="col-6 col-md-6 mb-3">
                            <app-form-label [label]="'CALEVENTREPEATEND' | translate"></app-form-label>
                            <app-form-dropdown
                              [fG]="calendarEventForm"
                              [fCN]="'repeatEndType'"
                              [dataSource]="repeatEndOptions"
                              [placeholder]="'SELECT' | translate"
                            ></app-form-dropdown>
                        </div>
                        <div class="col-6 col-md-6 mb-3">
                          <div>&nbsp;</div>
                          <!-- Repeat Until Date -->
                          <div [class.d-none]="calendarEventForm.get('repeatEndType')?.value !== 'until'">
                            <app-form-date
                              [fG]="calendarEventForm"
                              [fCN]="'repeatDaysUntil'"
                              [placeholder]="'CALEVENSELECTSTARTDATE' | translate"
                            ></app-form-date>
                          </div>
      
                          <!-- Repeat Count -->
                          <div [class.d-none]="calendarEventForm.get('repeatEndType')?.value !== 'count'">
                            <app-form-numeric [fG]="calendarEventForm" [fCN]="'repeatDaysCount'"></app-form-numeric>
                          </div>
                        </div>
                      </div>
                    </div>
      
                    <!-- Repeat On Section -->
                    <div class="col-12 col-md-6">
                      <!-- Day of Month Option -->
                      <div class="d-flex align-items-center gap-2 mb-2">
                        <app-form-radio [fG]="calendarEventForm" [fCN]="'monthlyRepeatMode'" [value]="true" [placeholder]="'DAY' | translate" [cssClass]="'e-normal'"></app-form-radio>
      
                        <app-form-numeric
                          [fG]="calendarEventForm"
                          [fCN]="'monthlyRepeatDay'"
                        ></app-form-numeric>
                      </div>
      
                      <!-- Ordinal Weekday Option -->
                      <div class="d-flex align-items-center gap-2">
                        <app-form-radio [fG]="calendarEventForm" [fCN]="'monthlyRepeatMode'" [value]="false" [placeholder]="'&nbsp;'" [cssClass]="'e-normal'"></app-form-radio>
      
                        <app-form-dropdown
                          [fG]="calendarEventForm"
                          [fCN]="'monthlyOrdinal'"
                          [dataSource]="ordinalOptions"
                        ></app-form-dropdown>
      
                        <app-form-dropdown
                          [fG]="calendarEventForm"
                          [fCN]="'monthlyWeekday'"
                          [dataSource]="weekdayOptionsLong"
                        ></app-form-dropdown>
                      </div>
                    </div>
                  </div>           
                }
              }
              @case(2) {
                <app-form-user-group-mail [allowEmails]="true" [allowPush]="true" [(user)]="participantsUserIDs" [(groups)]="participantsGroupIDs" (userChange)="onParticipantsChange()" (groupsChange)="onParticipantsChange()" (mailsChange)="participantsMails = $event; onParticipantsChange()" (pushUserIDsChange)="pushUserIDs = $event; onParticipantsChange()" (pushGroupIDsChange)="pushGroupIDs = $event; onParticipantsChange()"></app-form-user-group-mail>
              }
            }
          </form>
        </div>

        <div class="d-flex justify-content-between mt-3 d-none d-md-flex">
          @if(activeStep > 0){
            <app-form-button
              [text]="'PREV' | translate"
              (click)="handleStepChange(activeStep - 1)" 
              [cssClass]="'e-outline w-20'">
            </app-form-button>
          }
          @if(activeStep < steps.length - 1){
            <app-form-button 
              [text]="'NEXT' | translate" 
              (click)="handleStepChange(activeStep + 1)" 
              [cssClass]="'e-secondary ms-auto w-20'">
            </app-form-button>
          }
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #footerTemplate>
    <div class="d-md-none d-flex gap-2 p-2">
      <div class="flex-shrink-0">
        @if(activeStep > 0){
          <app-form-button 
            [text]="'PREV' | translate" 
            (click)="handleStepChange(activeStep - 1)" 
            [cssClass]="'e-outline w-100 mx-1'">
          </app-form-button>
        } @else {
          <!-- Dummy button to keep the space for the flex container -->
          <app-form-button 
            [text]="'PREV' | translate" 
            [cssClass]="'e-outline invisible w-100 mx-1'">
          </app-form-button>
        }
      </div>
      <div class="flex-grow-1 d-flex justify-content-center">
        <app-form-button [text]="'SAVE' | translate" [disabled]="calendarEventForm.invalid" (click)="save()" [cssClass]="'e-primary w-90'"></app-form-button>
      </div>
      <div class="flex-shrink-0">
        @if(activeStep < steps.length - 1){
          <app-form-button 
            [text]="'NEXT' | translate" 
            (click)="handleStepChange(activeStep + 1)" 
            [cssClass]="'e-secondary w-100 mx-1'">
          </app-form-button>
        }
        @if(activeStep === steps.length - 1) {
          <!-- Dummy button to keep the space for the flex container -->
          <app-form-button 
            [text]="'NEXT' | translate" 
            [cssClass]="'e-secondary invisible w-100 mx-1'">
          </app-form-button>
        }

      </div>
    </div>
  </ng-template>
</ejs-dialog>

<!-- small dialog which popups up in case if the user is editing the master event itself to ask the user if he wants to align all existing overwrites of occurances to the new master or leave them as they are-->
<ejs-dialog target=".dialogs" class="autoheight-dialog" [visible]='visibleQuickDialog' [animationSettings]='dialogService.getAnimationSettings()' [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()' [isModal]="true" [allowDragging]="false" [width]="'40%'" [height]="'auto'" [zIndex]="999" [showCloseIcon]="false">
  <ng-template #header class="p-1">
    <app-headline [title]="'CALUPDATEMASTER' | translate" [type]="'h5'"></app-headline>
  </ng-template>
  <ng-template #content>
    <div class="d-flex flex-column p-3">
      <div class="mb-3">
        <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">{{ 'CALUPDATEMASTERQUESTION' | translate }}</app-content>
      </div>
      
      <div class="d-flex flex-column gap-2">
        <!-- Check All -->
        <div class="mb-2">
          <ejs-checkbox
            name="allAdaptChecked"
            [(ngModel)]="allAdaptChecked"
            [labelPosition]="'After'"
            [label]="'CALADAPTALL' | translate"
            [cssClass]="'fw-bold'"
          ></ejs-checkbox>
        </div>

        <div class="ms-3 d-flex flex-column gap-2">
          <!-- Details Section -->
          <ejs-checkbox
            name="adaptDetails"
            [(ngModel)]="adaptDetails"
            [disabled]="!section0Edited"
            [labelPosition]="'After'"
            [label]="steps[0]"
          ></ejs-checkbox>

          <!-- Date/Location Section -->
          <ejs-checkbox
            name="adaptDateLocation"
            [(ngModel)]="adaptDateLocation"
            [disabled]="!section1Edited"
            [labelPosition]="'After'"
            [label]="steps[1]"
          ></ejs-checkbox>

          <!-- Guests Section -->
          <ejs-checkbox
            name="adaptGuests"
            [(ngModel)]="adaptGuests"
            [disabled]="!section2Edited"
            [labelPosition]="'After'"
            [label]="steps[2]"
          ></ejs-checkbox>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #footerTemplate>
    <div class="d-flex align-items-center gap-2 w-100 p-2">
      <app-form-button
        [text]="'SAVE' | translate"
        (click)="saveQuickDialog()"
        [cssClass]="'e-primary'"
      ></app-form-button>      

      <app-form-button
        [text]="'CANCEL' | translate"
        (click)="cancelQuickDialog()"
        [cssClass]="'e-outline mx-1'"
      ></app-form-button>
    </div>
  </ng-template>
</ejs-dialog>

